<template>
	<v-radio
		:color="color"
		:disabled="disabled"
		:label="label"
		:readonly="readOnly"
		:value="value"
		:on-icon="onIcon"
		:off-icon="offIcon"
		:background-color="backgroundColor"
		v-bind="$attrs"
		v-on="$listeners"
	>
		<template v-slot:label>
			<slot name="label" />
		</template>
	</v-radio>
</template>

<script>

export default {
	name: 'KRadio',
	props: {
		color: String,
		disabled: Boolean,
		label: String,
		readOnly: Boolean,
		value: [Boolean, String, Number],
		offIcon: String,
		onIcon: String,
		backgroundColor: String,
	},
}

</script>